import React from "react";
import ImageTag from "../../reusebale/imageTag";
import ParagraphTag from "../../reusebale/Paragraph";
import db from "../../../db/index.json";
import InfoCards from "../../reusebale/cards";
import { useSelector } from "react-redux";
import moment from "moment";
import { sumByKey } from "../../../utils/subscriptionHelper";

const ProfileInfo = ({ onBack, onAction }) => {
  const { userCompleteProfile } = useSelector((state) => state.auth);
  const { home } = db;

  console.log("User Comeplet", userCompleteProfile);

  return (
    <div>
      <div className="mt-3 flex justify-between">
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Personal Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[30%]">
              <ImageTag
                path={
                  userCompleteProfile?.personalInformation?.profileImage?.url ||
                  "/assets/daashboard/profile-complete/user-icon.png"
                }
                classes="w-[220px] rounded-full p-3"
                altText="logo"
              />
            </div>
            <div className="w-[70%]">
              <div className="pt-3">
                <ParagraphTag
                  content="Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={`${userCompleteProfile?.personalInformation?.firstName} ${userCompleteProfile?.personalInformation?.lastName}`}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-3">
                <ParagraphTag
                  content="Email Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={userCompleteProfile?.personalInformation?.email}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2">
                <ParagraphTag
                  content="Cell Number"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={
                    userCompleteProfile?.personalInformation?.phoneNumber
                  }
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
            </div>
          </div>
        </div>
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Company Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[30%] pl-2">
              <ImageTag
                path={
                  userCompleteProfile?.companyInformation?.companyLogo?.url ||
                  "/assets/daashboard/company-info.png"
                }
                classes="!w-[150px] h-[130px] rounded-full object-cover"
                altText="logo"
              />
            </div>
            <div className="w-[70%] px-2">
              <div className="pt-3">
                <ParagraphTag
                  content="Complete Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={
                    userCompleteProfile?.companyInformation?.completeAddress
                  }
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="City"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.companyInformation?.city}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Country"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.companyInformation?.country}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="State"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.companyInformation?.state}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Zip Code"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.companyInformation?.zipCode}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3 flex justify-between">
        <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4 flex justify-between items-center">
            <ParagraphTag
              content="Subscription Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
            <ParagraphTag
              content={"View All"}
              classes="text-themeColor font-popinsSemiBold text-sm cursor-pointer"
              onTrigger={() => onAction("Payment")}
            />
          </div>
          {(() => {
            const pkg = userCompleteProfile?.subscriptionPackage?.[0];
            if (!pkg) return (
              <p className="text-darkColor/40 font-popinsRegular text-xs px-6 py-6">No active subscription.</p>
            );
            const planName = pkg.packageData?.planName;
            const subType = pkg.packageData?.subscriptionType || pkg.subscriptionType;
            const allowProperties = sumByKey(userCompleteProfile?.subscriptionPackage, "allowProperties");
            const endDate = moment(pkg.endDate).format("MM/DD/YY");
            const amount = pkg.amount || pkg.packageData?.totalPackagePrice;
            const discount = pkg.packageData?.discountAmount;
            const typeLabel = subType === "yearly" ? "Annual" : subType === "quarterly" ? "Quarterly" : "Monthly";

            return (
              <div className="px-4 pb-5 pt-2">
                {/* Metrics row */}
                <div className="rounded-xl border border-gray-100 overflow-hidden">
                  <div className="flex items-center gap-2 px-4 py-2.5 bg-gray-50 border-b border-gray-100">
                    <p className="text-themeColor font-popinsSemiBold text-sm">{planName}</p>
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-popinsMedium bg-green-100 text-green-700">
                      Active
                    </span>
                  </div>
                <div className="grid grid-cols-4 divide-x divide-gray-100">
                  <div className="flex flex-col items-center py-3 px-2 bg-gray-50">
                    <p className="text-darkColor font-popinsSemiBold text-sm">
                      {amount ? `$${Number(amount).toLocaleString()}` : "—"}
                    </p>
                    <p className="text-darkColor/40 font-popinsRegular text-xs mt-0.5">Amount</p>
                  </div>
                  <div className="flex flex-col items-center py-3 px-2 bg-gray-50">
                    <p className="text-darkColor font-popinsSemiBold text-sm">{allowProperties}</p>
                    <p className="text-darkColor/40 font-popinsRegular text-xs mt-0.5">Properties</p>
                  </div>
                  <div className="flex flex-col items-center py-3 px-2 bg-gray-50">
                    <p className="text-darkColor font-popinsSemiBold text-sm">{typeLabel}</p>
                    <p className="text-darkColor/40 font-popinsRegular text-xs mt-0.5">Billing</p>
                  </div>
                  <div className="flex flex-col items-center py-3 px-2 bg-gray-50">
                    <p className="text-darkColor font-popinsSemiBold text-sm">{endDate}</p>
                    <p className="text-darkColor/40 font-popinsRegular text-xs mt-0.5">End Date</p>
                  </div>
                </div>
                </div>

                {discount && discount !== "$0" && (
                  <div className="flex items-center justify-between mt-3">
                    <p className="text-darkColor/40 font-popinsRegular text-xs">Discount Applied</p>
                    <p className="text-green-600 font-popinsSemiBold text-xs">{discount}</p>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
        {/* <div className="w-[49%] bg-white rounded-xl">
          <div className="px-4 pt-4">
            <ParagraphTag
              content="Bank Information"
              classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
            />
          </div>
          <div className="flex mt-1 items-center">
            <div className="w-[70%] px-2 pl-6 mb-5">
              <div className="pt-3">
                <ParagraphTag
                  content="Holder Name"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={userCompleteProfile?.bankInformation?.holderName}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                />
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder State"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.bankInformation?.holderState}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder City"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.bankInformation?.holderCity}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
              <div className="pt-2 flex">
                <div className="w-[50%]">
                  <ParagraphTag
                    content="Holder Zip Code"
                    classes="text-darkColor font-popinsSemiBold text-sm"
                  />
                  <ParagraphTag
                    content={userCompleteProfile?.bankInformation?.holderZip}
                    classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs "
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div className="flex flex-wrap mt-5" id="gk-cards">
        {home.cardData2.map((item, i) => (
          <InfoCards item={item} onTrigger={onAction} />
        ))}
      </div>
    </div>
  );
};

export default ProfileInfo;
